import React, {
  useEffect,
  useState,
} from "react";

import { useLocation } from "react-router-dom";

import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

const LifePage = () => {
  const [open, setOpen] =
    useState(false);

  const location =
    useLocation();

  const queryParams =
    new URLSearchParams(
      location.search
    );

  const typeFromURL =
    queryParams.get("type") ||
    "all";

  const [
    activeTab,
    setActiveTab,
  ] = useState(typeFromURL);

  const [
    academics,
    setAcademics,
  ] = useState([]);

  const [
    galleryAwards,
    setGalleryAwards,
  ] = useState([]);

  const [
    birthday,
    setBirthday,
  ] = useState([]);

  const [
    student,
    setStudent,
  ] = useState([]);

  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    setActiveTab(
      typeFromURL
    );
  }, [typeFromURL]);

  useEffect(() => {
    fetch(
      "https://deoria.ilakshyaerp.in/api/academics"
    )
      .then((res) =>
        res.json()
      )
      .then((data) =>
        setAcademics(
          Array.isArray(
            data
          )
            ? data
            : []
        )
      );

    fetch(
      "https://deoria.ilakshyaerp.in/api/galleryAwards"
    )
      .then((res) =>
        res.json()
      )
      .then((data) =>
        setGalleryAwards(
          Array.isArray(
            data
          )
            ? data
            : []
        )
      );

    fetch(
      "https://deoria.ilakshyaerp.in/api/birthday"
    )
      .then((res) =>
        res.json()
      )
      .then((data) =>
        setBirthday(
          Array.isArray(
            data
          )
            ? data
            : []
        )
      );

    fetch(
      "https://deoria.ilakshyaerp.in/api/student"
    )
      .then((res) =>
        res.json()
      )
      .then((data) =>
        setStudent(
          Array.isArray(
            data
          )
            ? data
            : []
        )
      );
  }, []);

  const allData = [
    ...academics.map(
      (i) => ({
        ...i,
        type:
          "academics",
      })
    ),

    ...galleryAwards.map(
      (i) => ({
        ...i,
        type:
          "galleryAwards",
      })
    ),

    ...birthday.map(
      (i) => ({
        ...i,
        type:
          "birthday",
      })
    ),

    ...student.map(
      (i) => ({
        ...i,
        type:
          "student",
      })
    ),
  ];

  const filteredData =
    activeTab === "all"
      ? allData
      : allData.filter(
        (item) =>
          item.type ===
          activeTab
      );

  const getImage = (
    item
  ) => {
    if (
      item.type ===
      "academics"
    ) {
      return `https://deoria.ilakshyaerp.in/uploads/academics/${item.image}`;
    }

    if (
      item.type ===
      "galleryAwards"
    ) {
      return `https://deoria.ilakshyaerp.in/uploads/galleryAwards/${item.image}`;
    }

    if (
      item.type ===
      "birthday"
    ) {
      return `https://deoria.ilakshyaerp.in/uploads/birthday/${item.image}`;
    }

    if (
      item.type ===
      "student"
    ) {
      return `https://deoria.ilakshyaerp.in/uploads/student/${item.image}`;
    }

    return "";
  };

  return (
    <>
      <Header
        toggleSidebar={() =>
          setOpen(true)
        }
      />

      <Sidebar
        isOpen={open}
        close={() =>
          setOpen(false)
        }
      />

      <div className="container">

        <h1 className="life-page-title">
          Life At School
        </h1>

        <div className="life-tabs">

          <button
            onClick={() =>
              setActiveTab(
                "all"
              )
            }
            className={
              activeTab ===
                "all"
                ? "active"
                : ""
            }
          >
            All
          </button>

          <button
            onClick={() =>
              setActiveTab(
                "academics"
              )
            }
            className={
              activeTab ===
                "academics"
                ? "active"
                : ""
            }
          >
            Academics
          </button>

          <button
            onClick={() =>
              setActiveTab(
                "galleryAwards"
              )
            }
            className={
              activeTab ===
                "galleryAwards"
                ? "active"
                : ""
            }
          >
            Gallery &
            Awards
          </button>

          <button
            onClick={() =>
              setActiveTab(
                "birthday"
              )
            }
            className={
              activeTab ===
                "birthday"
                ? "active"
                : ""
            }
          >
            Birthday
          </button>

          <button
            onClick={() =>
              setActiveTab(
                "student"
              )
            }
            className={
              activeTab ===
                "student"
                ? "active"
                : ""
            }
          >
            Student Work
          </button>

        </div>

        <div className="life-gallery-grid">

          {filteredData.length >
            0 ? (
            filteredData.map(
              (
                item,
                i
              ) => (
                <div className="life-gallery-card" key={i}>
                  <img
                    src={getImage(item)}
                    alt=""
                    onClick={() =>
                      setSelectedImage(getImage(item))
                    }
                    style={{ cursor: "pointer" }}
                  />
                </div>
              )
            )
          ) : (
            <p className="life-empty">
              No data available
            </p>
          )}

        </div>

      </div>

      {selectedImage && (
        <div
          className="image-modal"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="close-btn"
            onClick={() => setSelectedImage(null)}
          >
            ✕
          </button>

          <img
            src={selectedImage}
            alt="Preview"
            className="modal-image"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}

      <Footer />
    </>
  );
};

export default LifePage;